import { createContext, useContext } from "react";

export const SAFE_WORKSPACE_PAGES = {
  "assessment/wizard/step-0": ["위험성평가", "STEP 0 평가 준비"],
  "assessment/wizard/step-1": ["위험성평가", "STEP 1 대상/위험성평가"],
  "assessment/wizard/step-2": ["위험성평가", "STEP 2 개선대책"],
  "assessment/wizard/step-3": ["위험성평가", "STEP 3 완료 처리/승인"],
  "monitoring/tbm": ["현장 안전 관리", "TBM 관리"],
  "monitoring/inspection": ["현장 안전 관리", "현장 안전점검"],
  "monitoring/actions": ["현장 안전 관리", "조치 요청·처리 관리"],
  "worker/hazard-review": ["현장 안전 관리", "위험요인 제안 검토"],
  "monitoring/education": ["현장 안전 관리", "안전보건교육 관리"],
  "monitoring/legal-certs": ["현장 안전 관리", "설비 검사·인증"],
  "monitoring/committee": ["현장 안전 관리", "안전보건위원회"],
  "register/cause": ["현장 안전 관리", "설비별 위험요인 설정"],
  "standard/machine": ["기준정보", "설비 정보 관리"],
  "standard/process": ["기준정보", "공정 정보 관리"],
  "standard/location": ["기준정보", "라인 관리"],
  "standard/cause": ["기준정보", "공통 위험요인 관리"],
  "standard/msds": ["기준정보", "MSDS 관리"],
  "register/machine": ["기준정보", "설비별 공정 설정"],
  "standard/eval-cycle": ["기준정보", "평가 주기 설정"],
  "worker/hazard-proposal": ["근로자 기능", "유해·위험요인 제안"],
  "worker/action-inbox": ["근로자 기능", "내 조치 업무"],
  "monitoring/integrated-report": ["보고서", "보고서"],
  organization: ["조직관리", "조직관리"],
};

// An explicit allowlist keeps Home, legacy pages and other systems unchanged.
export const getSafeWorkspacePage = (pathname) => {
  const match = pathname.match(/^\/safe\/[^/]+\/[^/]+\/(.+?)\/?$/);
  const path = match?.[1];
  if (path?.startsWith("assessment/wizard/step-")) return null;
  const page = SAFE_WORKSPACE_PAGES[path];
  return page ? {
    path,
    category: page[0],
    title: page[1],
    compact: ["현장 안전 관리", "기준정보"].includes(page[0]),
  } : null;
};

export const SafeWorkspaceContext = createContext(null);
export const useSafeWorkspace = () => useContext(SafeWorkspaceContext);
